import { trigger, style, transition, animate } from '@angular/animations';

export const fadeInOutAnimation = [
    trigger('fadeIn', [transition(':enter', [style({ opacity: 0 }), animate('0.6s ease-in', style({ opacity: 1 }))])]),
    trigger('fadeOut', [transition(':leave', [animate('0.6s ease-out', style({ opacity: 0 }))])]),
    trigger('fadeInSlide', [
        transition(':enter', [
            style({ opacity: 0, transform: 'translateY(16px)' }),
            animate('0.3s ease-in-out', style({ opacity: 1, transform: 'translateY(0)' }))
        ])
    ]),
    trigger('fadeOutSlide', [
        transition(':leave', [
            style({ opacity: 1, transform: 'translateY(0)' }),
            animate('0.3s ease-in-out', style({ opacity: 0, transform: 'translateY(16px)' }))
        ])
    ])
];
